// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9b8d6142","455":"f32529e2","977":"4288e1ed"}[chunkId] + ".chunk.js";
};